"use client"

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "toast shadow-lg rounded-[var(--border-radius)] border px-4 py-3 gap-2 " +
            "bg-[var(--normal-bg)] text-[var(--normal-text)] border-[var(--normal-border)] " +
            "data-[type=success]:bg-[var(--success-bg)] data-[type=success]:text-[var(--success-text)] data-[type=success]:border-[var(--success-border)] " +
            "data-[type=error]:bg-[var(--error-bg)] data-[type=error]:text-[var(--error-text)] data-[type=error]:border-[var(--error-border)] " +
            "data-[type=warning]:bg-[var(--warning-bg)] data-[type=warning]:text-[var(--warning-text)] data-[type=warning]:border-[var(--warning-border)] " +
            "data-[type=info]:bg-[var(--info-bg)] data-[type=info]:text-[var(--info-text)] data-[type=info]:border-[var(--info-border)]",
          title: "text-sm font-medium leading-none",
          description: "text-sm opacity-90",
          actionButton:
            "bg-primary text-primary-foreground hover:bg-primary/90",
          cancelButton: "bg-muted text-muted-foreground hover:bg-muted/80",
        },
      }}
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",

          "--success-bg": "var(--toast-success-bg)",
          "--success-text": "var(--toast-success-text)",
          "--success-border": "var(--toast-success-border)",

          "--error-bg": "var(--toast-error-bg)",
          "--error-text": "var(--toast-error-text)",
          "--error-border": "var(--toast-error-border)",

          "--warning-bg": "var(--toast-warning-bg)",
          "--warning-text": "var(--toast-warning-text)",
          "--warning-border": "var(--toast-warning-border)",

          "--info-bg": "var(--toast-info-bg)",
          "--info-text": "var(--toast-info-text)",
          "--info-border": "var(--toast-info-border)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
